import React, { Component, useEffect } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import config from '../../config/config';
// import WOW from 'wowjs';
import { WOW } from 'wowjs';

const BannerV2 = ({data}) => {

	let publicUrl = process.env.PUBLIC_URL+'/'
	let imagealt = 'image'

	const $ = window.$;

	useEffect(() => {
		if(data) {
			$('.ltn__slider-11-active').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
				var i = (currentSlide ? currentSlide : 0) + 1;
				$('.ltn__slider-11-pagination-count .count').text('0'+i);
				$('.ltn__slider-11-pagination-count .total').text('0' + slick.slideCount);

				$('.ltn__slider-11-slide-item-count .count').text('0'+i);
				$('.ltn__slider-11-slide-item-count .total').text('/0' + slick.slideCount);
				new WOW().init();
			}).slick({
				dots: false, /* slider left or right side pagination count with line */
				arrows: false, /* slider arrow  */
				appendDots: '.ltn__slider-11-pagination-count',
				infinite: true,
				autoplay: false,
				autoplaySpeed: 10000,
				speed: 500,
				asNavFor: '.ltn__slider-11-img-slide-arrow-active',
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
				nextArrow: '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>',
				responsive: [
					{
						breakpoint: 1600,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							dots: false
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							dots: false
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							dots: false
						}
					},
					{
						breakpoint: 575,
						settings: {
							arrows: false,
							dots: false,
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});

			$('.ltn__slider-11-img-slide-arrow-active').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				initialSlide: 2,
				centerMode: false,
				centerPadding: '0px',
				asNavFor: '.ltn__slider-11-active',
				dots: false, /* image slide dots */
				arrows: false, /* image slide arrow */
				centerMode: true,
				focusOnSelect: true,
				prevArrow: '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
				nextArrow: '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>',
				responsive: [
					{
						breakpoint: 1600,
						settings: {
							arrows: false,
							dots: false
						}
					},
					{
						breakpoint: 1200,
						settings: {
							arrows: true,
							dots: false
						}
					},
					{
						breakpoint: 768,
						settings: {
							arrows: true,
							dots: false
						}
					},
					{
						breakpoint: 575,
						settings: {
							arrows: true,
							dots: false,
						}
					}
				]
			});
		}
	}, [data])

    return  <div className="ltn__slider-area product-key-feature ltn__slider-11  ltn__slider-11-slide-item-count-show--- ltn__slider-11-pagination-count-show--- section-bg-1">
			  <div className="ltn__slider-11-inner">
			    <div className="ltn__slider-11-active">
			      {/* slide-item */}
				  {data && data?.map((item, index) => {
					return (
						<div className="ltn__slide-item ltn__slide-item-2 ltn__slide-item-3-normal ltn__slide-item-3 ltn__slide-item-11" key={index}>
							{/* <div className="video-overlay"></div> */}
							<div className="ltn__slide-item-inner">
							<div className="container">
								<div className="row">
								<div className="col-lg-12 align-self-center">
									<div className="slide-item-info">
										<div className="slide-item-info-inner ltn__slide-animation">
											{/* <div className="slide-video mb-50 d-none">
											<a className="ltn__video-icon-2 ltn__video-icon-2-border" href="https://www.youtube.com/embed/tlThdr3O5Qo" data-rel="lightcase:myCollection">
												<i className="fa fa-play" />
											</a>
											</div> */}
											{/* <h6 className="slide-sub-title white-color--- animated mb-0">Key Feature</h6> */}
											{/* <h1 className="slide-title animated mt-0">{item?.keyfeatures}</h1> */}
										</div>
									</div>
									<div className="slide-item-img">
										<img src={item?.keyimage ? config.assetUrl + "uploads/product_image/" + item?.keyimage : publicUrl + "assets/img/llabdhi_img/product_img.jpg"} alt="#" />
									</div>
								</div>
								</div>
							</div>
							</div>
						</div>
					)
				  })}
			      
			    </div>
			    {/* slider-4-pagination */}
			    <div className="ltn__slider-11-pagination-count">
			      <span className="count" />
			      <span className="total" />
			    </div>
			    {/* slider-4-img-slide-arrow */}
			    <div className="ltn__slider-11-img-slide-arrow">
			      <div className="ltn__slider-11-img-slide-arrow-inner">
			        <div className="ltn__slider-11-img-slide-arrow-active">
						{data && data?.map((item, index) => {
						return (
							<div className="image-slide-item" key={index}>
								<img src={item?.keyimage ? config.assetUrl + "uploads/product_image/" + item?.keyimage : publicUrl + "assets/img/llabdhi_img/product_img.jpg"} alt="Flower Image" />
							</div>
							
						)})}
						{/* <div className="image-slide-item">
								<img src={publicUrl+"assets/img/llabdhi_img/steel beams possible baner.png"} alt="Flower Image" />
							</div>
							<div className="image-slide-item">
								<img src={publicUrl+"assets/img/llabdhi_img/steel beams possible baner.png"} alt="Flower Image" />
							</div>
							<div className="image-slide-item">
								<img src={publicUrl+"assets/img/llabdhi_img/steel beams possible baner.png"} alt="Flower Image" />
							</div> */}
			        </div>
			        {/* slider-4-slide-item-count */}
			        <div className="ltn__slider-11-slide-item-count">
			          <span className="count" />
			          <span className="total" />
			        </div>
			      </div>
			    </div>
			  </div>
			</div>

	}


export default BannerV2